import type { AppSidebarData } from '@repo/ui';
import { FolderTree } from 'lucide-react';
import { getAdminSysNavItems } from './get-admin-sys-nav-items';

interface IGetSysNavItemsParams {
  pathname?: string;
  isAdmin: boolean;
}

export function getSysNavItems({
  pathname,
  isAdmin,
}: IGetSysNavItemsParams): AppSidebarData['navMain'] {
  const isInGroup = (urls: string[]): boolean =>
    Boolean(pathname && urls.some((u) => pathname.startsWith(u)));

  if (!isAdmin) {
    return [
      {
        title: 'Triage',
        url: '/sys/triage',
        icon: FolderTree,
        isActive: isInGroup(['/sys/triage', '/sys/collections']),
      },
    ];
  }

  return getAdminSysNavItems(isInGroup);
}
